// extracted by mini-css-extract-plugin
module.exports = {"ItemSet":"Sponsor_ItemSet__SrTIH","Item":"Sponsor_Item__NhPfZ","Logo":"Sponsor_Logo__wvKsV"};